import React, { useState } from 'react';

import CalendarView from './Components/CalendarView/CalendarView';
import CalendarHeader from './Components/CalendarHeader/CalendarHeader';
import CalendarSettings from './Components/CalendarHeader/CalendarSettings';
import TeamCalendarsSidebar from './Components/SideBar/TeamCalendarsSidebar';

import CreateEventModal from './Components/CreateEventModal/CreateEventModal';
import EventPreviewModal from './Components/EventPreviewModal/EventPreviewModal';

import { useCalendarContext } from './Context/CalendarContext';

function CalendarContainer() {
  const { showCreateEventModal, showEventPreviewModal, showCalendarSettings } = useCalendarContext();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  return (
    <>
      {showCreateEventModal && <CreateEventModal showCreateEventModal={showCreateEventModal} />}
      {showEventPreviewModal && <EventPreviewModal showEventPreviewModal={showEventPreviewModal} />}
      {showCalendarSettings && <CalendarSettings />}
      <div className="full-calendar-wrap px-2">
        <CalendarHeader />
        <CalendarView isCollapsed={isCollapsed} toggleSidebar={toggleSidebar} />
      </div>
    </>
  );
}

export default CalendarContainer;
